import styled, {useTheme} from "styled-components";
import {Theme} from "../../theme";
import React, {useEffect, useState, useRef, useContext} from "react";
import {MdCheck, MdClose, MdRefresh} from "react-icons/md";
import {BANKART_API_KEY, ALLOW_DIFFERENT_BILLING_ADDRESS} from "../../globals";
import {proto} from "../../proto/messages";
import {SocketApi, SocketApiAckStatus} from "proto_socket_typescript";
import {billing, cvv_types} from "../../proto/compiled";
import {CvvRadio} from "../../components/radio";
import {CvvInputField} from "./input";
import {CvvTextInput} from "./text_input";
import {StringFormatters} from "../../utils";
import {BankartStore} from "../../stores/bankart_store";
import {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {MladiVoznikStore} from "../../stores/mladi_voznik_store";
import {FormStore} from "../../stores/form_store";
import {GmapsAddressPicker} from "./gmaps";
import {TailSpin} from "react-loader-spinner";

const Form = styled.form`
    display: flex;
`;

const BADGE_HEIGHT = 25;

const CreditCardLogos = () => (
    <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginTop: '8px',
    }}>
        {/* Card product logos - separate from security badges */}
        <div style={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
        }}>
            {/* Visa */}
            <svg width="40" height="25" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40 0H740C762.092 0 780 17.909 780 40V460C780 482.092 762.092 500 740 500H40C17.909 500 0 482.092 0 460V40C0 17.909 17.909 0 40 0Z" fill="#1434CB"/>
                <path d="M489.823 143.111C442.988 143.111 401.134 167.393 401.134 212.256C401.134 263.706 475.364 267.259 475.364 293.106C475.364 303.989 462.895 313.731 441.6 313.731C411.377 313.731 388.789 300.119 388.789 300.119L379.123 345.391C379.123 345.391 405.145 356.889 439.692 356.889C490.898 356.889 531.19 331.415 531.19 285.784C531.19 231.419 456.652 227.971 456.652 203.981C456.652 195.455 466.887 186.114 488.122 186.114C512.081 186.114 531.628 196.014 531.628 196.014L541.087 152.289C541.087 152.289 519.818 143.111 489.823 143.111ZM61.3294 146.411L60.1953 153.011C60.1953 153.011 79.8988 156.618 97.645 163.814C120.495 172.064 122.122 176.868 125.971 191.786L167.905 353.486H224.118L310.719 146.411H254.635L198.989 287.202L176.282 167.861C174.199 154.203 163.651 146.411 150.74 146.411H61.3294ZM333.271 146.411L289.275 353.486H342.756L386.598 146.411H333.271ZM631.554 146.411C618.658 146.411 611.825 153.318 606.811 165.386L528.458 353.486H584.542L595.393 322.136H663.72L670.318 353.486H719.805L676.633 146.411H631.554ZM638.848 202.356L655.473 280.061H610.935L638.848 202.356Z" fill="white"/>
            </svg>
            {/* Mastercard */}
            <svg width="40" height="25" viewBox="0 0 780 500" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40 0H740C762.092 0 780 17.909 780 40V460C780 482.092 762.092 500 740 500H40C17.909 500 0 482.092 0 460V40C0 17.909 17.909 0 40 0Z" fill="#000"/>
                <path d="M465.738 69.1387H313.812V342.088H465.738V69.1387Z" fill="#FF5A00"/>
                <path d="M323.926 205.613C323.926 150.158 349.996 100.94 390 69.1387C360.559 45.9902 323.42 32 282.91 32C186.945 32 109.297 109.648 109.297 205.613C109.297 301.578 186.945 379.227 282.91 379.227C323.42 379.227 360.559 365.237 390 342.088C349.94 310.737 323.926 261.069 323.926 205.613Z" fill="#EB001B"/>
                <path d="M670.711 205.613C670.711 301.578 593.062 379.227 497.098 379.227C456.588 379.227 419.449 365.237 390.008 342.088C430.518 310.231 456.082 261.069 456.082 205.613C456.082 150.158 430.012 100.94 390.008 69.1387C419.393 45.9902 456.532 32 497.041 32C593.062 32 670.711 110.154 670.711 205.613Z" fill="#F79E1B"/>
            </svg>
            {/* BA Maestro */}
            <svg width="40" height="25" viewBox="0 0 333334 199007" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31367 0h270601c8631 0 16474 3528 22156 9210 5683 5683 9211 13526 9211 22156v136275c0 8629-3529 16472-9211 22155-5683 5682-13526 9211-22155 9211H31368c-8629 0-16473-3528-22156-9211C3530 184114 2 176272 2 167641V31366c0-8631 3528-16474 9210-22156S22738 0 31369 0zm270601 10811H31367c-5647 0-10785 2315-14513 6043s-6043 8866-6043 14513v136275c0 5646 2315 10784 6043 14512 3729 3729 8867 6044 14513 6044h270601c5645 0 10783-2315 14512-6044 3728-3729 6044-8867 6044-14511V31368c0-5645-2315-10784-6043-14513-3728-3728-8867-6043-14513-6043z" fill="gray" fillRule="nonzero"/>
                <path fill="#6c6bbd" d="M187552 124712h-41775V49634h41775z"/>
                <path d="M148453 87167c0-15230 7131-28796 18235-37539-8120-6393-18369-10209-29506-10209-26368 0-47742 21377-47742 47748s21374 47748 47742 47748c11138 0 21386-3816 29506-10209-11104-8743-18235-22309-18235-37539z" fill="#eb001b"/>
                <path d="M243894 87167c0 26371-21374 47748-47742 47748-11138 0-21386-3816-29509-10209 11107-8743 18238-22309 18238-37539s-7131-28796-18238-37539c8123-6394 18371-10209 29509-10209 26368 0 47742 21377 47742 47748z" fill="#0099df"/>
                <path d="M221767 159309c137 0 264-24 380-76 118-52 222-122 309-209 89-87 158-191 210-313 48-118 76-246 76-383 0-136-28-264-76-382-52-119-122-224-210-313-87-88-191-158-309-207-115-52-243-76-380-76s-267 24-385 76c-122 48-228 119-316 207s-158 194-206 313c-52 118-76 246-76 382 0 137 24 265 76 383 48 121 118 225 206 313s194 158 316 209c119 52 249 76 385 76m-20130-13396c556 0 1354 106 1964 346l-850 2599c-583-240-1165-319-1724-319-1804 0-2705 1165-2705 3260v7109h-2759v-12677h2732v1539c717-1114 1752-1857 3342-1857m-36051 6657c-27-3952-2468-6657-6022-6657-3713 0-6311 2705-6311 6657 0 4028 2705 6654 6499 6654 1909 0 3658-477 5197-1776l-1354-2043c-1059 850-2413 1327-3685 1327-1776 0-3394-823-3791-3102l9414-1c27-346 54-689 54-1059m46133-4037c-567 0-1093 100-1581 298-486 200-908 480-1263 838s-635 789-838 1290c-204 501-304 1054-304 1654 0 604 100 1154 304 1654 204 501 483 932 838 1290s777 637 1263 838c489 200 1014 297 1581 297 568 0 1096-97 1582-297 489-200 914-480 1269-838 361-358 641-789 847-1290 204-501 304-1050 304-1654 0-601-100-1154-304-1654-206-501-486-932-847-1290-355-358-780-637-1269-838-486-198-1014-298-1582-298m0-2620c984 0 1894 170 2732 513 838 340 1564 810 2174 1408 613 598 1090 1306 1436 2119 346 817 519 1703 519 2659s-173 1843-519 2659c-346 813-823 1524-1436 2122-610 598-1336 1065-2174 1408-838 340-1748 510-2732 510-983 0-1894-170-2732-510-838-343-1557-810-2164-1408s-1084-1308-1430-2122c-346-817-519-1703-519-2659s173-1843 519-2659c346-813 823-1521 1430-2119s1326-1069 2164-1408c838-343 1749-513 2732-513m-71690 6657c0-2228 1460-4059 3846-4059 2280 0 3819 1752 3819 4059s-1539 4056-3819 4056c-2386 0-3846-1828-3846-4056m81523 5388v313h288c64 0 118-15 155-39 40-24 61-67 61-118s-21-91-61-115c-37-28-91-39-155-39h-288zm-30108-9207h-4508v5728c0 1272 449 2122 1830 2122 717 0 1618-240 2437-717l795 2359c-874 610-2252 983-3445 983-3263 0-4402-1752-4402-4696v-5780h-2574v-2520h2574v-3846h2784v3846h4508v2520zm-35302 2705c295-1830 1406-3078 3370-3078 1776 0 2917 1114 3209 3078h-6578zm21563-1988c-768-480-2331-1090-3950-1090-1512 0-2413 559-2413 1488 0 847 953 1087 2146 1244l1299 185c2759 401 4429 1567 4429 3794 0 2413-2122 4137-5780 4137-2070 0-3980-531-5491-1645l1299-2149c929 716 2310 1326 4220 1326 1882 0 2890-556 2890-1539 0-713-717-1114-2228-1323l-1299-185c-2838-401-4378-1673-4378-3740 0-2520 2070-4059 5279-4059 2016 0 3846 452 5170 1327l-1193 2228zm-27412 3102v-6339h-2756v1539c-878-1141-2201-1857-4004-1857-3555 0-6339 2783-6339 6657 0 3870 2784 6657 6339 6657 1803 0 3126-717 4004-1858v1539h2756v-6338zm-15539 6338v-7956c0-2996-1909-5012-4985-5039-1618-28-3290 476-4456 2256-874-1406-2255-2256-4192-2256-1351 0-2677 398-3713 1882v-1563h-2756v12677h2783v-7027c0-2201 1220-3370 3102-3370 1831 0 2759 1193 2759 3342v7055h2784v-7027c0-2201 1275-3370 3102-3370 1885 0 2787 1193 2787 3342v7055h2783z" fill="#231f20"/>
            </svg>
        </div>
    </div>
);

const style_smallcard = {
    width: '45px',
    padding: '0px',
    border: 'none',
    outline: 'none',
    transition: 'all 300ms',
    fontSize: '14px',
    fontWeight: '300',
    fontFamily: '-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif',
}

const style_smallcard2 = {
    ...style_smallcard,
    fontWeight: '350',
    height: '17px',
}

const style_nospin = {
    appearance: 'textfield',
    '-webkit-appearance': 'none',
    '-moz-appearance': 'textfield',
    '::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: '0',
    },
    '::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: '0',
    }
}

export const BankartPayment = observer(({
                                            mladiVoznikStore,
                                            formStore,
                                            disabled,
                                            inProgress,
                                            onPaymentErrorRetry,
                                        }: {
    mladiVoznikStore: MladiVoznikStore,
    formStore: FormStore,
    disabled?: boolean,
    inProgress?: (p: boolean) => void,
    onPaymentErrorRetry: () => void
}) => {

    const bankart = useMemo(() => new window.PaymentJs(), []);
    const theme = useTheme() as Theme;
    const buttonRef = useRef<HTMLButtonElement>(null);
    const success = formStore.cardPaymentDone;
    const paymentError = formStore.cardPaymentError ? 'Napaka pri plačilu' : undefined;
    const progress = formStore.paymentInProgress;
    const store = useMemo(() => new BankartStore(formStore.api, mladiVoznikStore), []);
    if (store.addressNecessary) {
        mladiVoznikStore.form.step6!.differentBillingAddress = true;
    }
    const differentBillingInfo = !!(store.addressNecessary || mladiVoznikStore.form.step6?.differentBillingAddress);
    const [isMobilePaymentLayout, setIsMobilePaymentLayout] = useState<boolean>(() =>
        typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
    );

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const updateMobileLayout = () => setIsMobilePaymentLayout(mediaQuery.matches);
        updateMobileLayout();
        if (mediaQuery.addEventListener) {
            mediaQuery.addEventListener('change', updateMobileLayout);
            return () => mediaQuery.removeEventListener('change', updateMobileLayout);
        }
        mediaQuery.addListener(updateMobileLayout);
        return () => mediaQuery.removeListener(updateMobileLayout);
    }, []);

    useEffect(() => {
        // enables or disables inputs
        if (progress) {
            const div = document.getElementById('bankart_payment') as HTMLDivElement | null;
            if (div) {
                const inputs = div.querySelectorAll('input');
                inputs.forEach((input) => {
                    input.disabled = true;
                });
            }
        } else {
            const div = document.getElementById('bankart_payment') as HTMLDivElement | null;
            if (div) {
                const inputs = div.querySelectorAll('input');
                inputs.forEach((input) => {
                    input.disabled = false;
                });
            }
        }
    }, [progress]);
    useEffect(() => {
        if (paymentError) {
            inProgress!(false);
            store.bankartError = paymentError;
        }
    }, [paymentError]);

    useEffect(() => {
        if (bankart.initialized) return;
        bankart.init(BANKART_API_KEY, 'card_number', 'card_cvc', function (payment: any) {
            payment.setNumberStyle({
                    width: '100%',
                    padding: '0px',
                    border: 'none',
                    outline: 'none',
                    transition: 'all 300ms',
                    fontFamily: '-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif',
                    ...style_nospin,
                    fontSize: '14px',
                    fontWeight: '300',
                    backgroundColor: 'white'
                }
            );
            payment.setCvvStyle({
                ...style_smallcard,
                ...style_nospin,
                width: '35px',
            });
            payment.setCvvPlaceholder('CVC');
            payment.setNumberPlaceholder('Številka kartice');
            payment.enableAutofill();
            payment.onAutofill(function (data: any) { // todo: test in production (disabled by service on http because of security)
                mladiVoznikStore.form.step6!.billingFirstName = data.first_name;
                mladiVoznikStore.form.step6!.billingLastName = data.last_name;
                store.year = data.year;
                store.month = data.month;
            })
            payment.numberOn('enter', () => handleKeyDown('ArrowRight', 'card_month', undefined));
            payment.cvvOn('enter', () => {
                if (buttonRef.current) {
                    buttonRef.current.click();
                }
            });

            payment.numberOn('input', () => {
                if (store.startOfForm) {
                    store.startOfForm = false;
                }
                if (paymentError) {
                    store.error = undefined;
                    store.bankartError = undefined;
                }
                store.formDataFilled(mladiVoznikStore);
            })
            payment.cvvOn('input', () => {
                if (store.startOfForm) {
                    store.startOfForm = false;
                }
                if (paymentError) {
                    store.error = undefined;
                    store.bankartError = undefined;
                }
                store.formDataFilled(mladiVoznikStore);
            });
        });
    });

    useEffect(() => {
        if (!bankart.initialized) return;
        if (success) {
            bankart.setNumberStyle({
                backgroundColor: 'rgba(0, 255, 0, .01)',
            });
            bankart.setCvvStyle({
                backgroundColor: 'rgba(0, 255, 0, .01)',
            });
        } else if (paymentError) {
            bankart.setNumberStyle({
                backgroundColor: 'rgba(255, 0, 0, .01)',
            });
            bankart.setCvvStyle({
                backgroundColor: 'rgba(255, 0, 0, .01)',
            });
        }
    }, [success, paymentError, store, bankart]);



    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement> | string, nextInputId: string | undefined, prevInputId: string | undefined) => {
        if (typeof e === 'string') {
            if ((e === 'ArrowRight') && nextInputId) {
                const nextInput = document.getElementById(nextInputId) as HTMLInputElement | null;
                if (nextInput) {
                    nextInput.focus();
                    setTimeout(() => {
                        nextInput.setSelectionRange(0, 0);
                    }, 0);
                }
            } else if (e === 'ArrowLeft' && prevInputId) {
                const prevInput = document.getElementById(prevInputId) as HTMLInputElement | null;
                if (prevInput) {
                    prevInput.focus();
                    setTimeout(() => {
                        prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
                    }, 0);
                }
            }
            return;
        }
        const {key, target} = e;
        const input = target as HTMLInputElement;
        const cursorPosition = input.selectionStart;

        // If Right Arrow is pressed and the cursor is at the end, move to the next field
        if ((key === "ArrowRight" || key === "Enter") && cursorPosition === input.value.length && nextInputId) {
            const nextInput = document.getElementById(nextInputId) as HTMLInputElement | null;
            if (nextInput) {
                nextInput.focus();
                setTimeout(() => {
                    // Ensure the cursor is at the start
                    nextInput.setSelectionRange(0, 0);
                }, 0);
            }
        }

        // If Left Arrow is pressed and the cursor is at the start, move to the previous field
        if (key === "ArrowLeft" && cursorPosition === 0 && prevInputId) {
            const prevInput = document.getElementById(prevInputId) as HTMLInputElement | null;
            if (prevInput) {
                prevInput.focus();
                setTimeout(() => {
                    // Ensure the cursor is at the end
                    prevInput.setSelectionRange(prevInput.value.length, prevInput.value.length);
                }, 0);
            }
        }
    };
    const handleToggle = () => {
        store.flik = !store.flik;
    }


    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) =>
        store.submit(e, mladiVoznikStore, store, paymentError !== undefined, onPaymentErrorRetry, inProgress, bankart);

    const btnDisabled = disabled || !bankart.init || store.error !== undefined || store.startOfForm || success
        || progress || !store.formFilled

    const spinning = !success && !paymentError && btnDisabled && progress;

    return <div>
        <Form onSubmit={handleSubmit}>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    padding: '0px',
                    marginBottom: '10px',
                    width: '100%',
                }}
            >
                <div style={
                    {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        padding: '0px',
                        marginBottom: '10px',
                    }
                }>
                    {/*<label>*/}
                    {/*    <input*/}
                    {/*        type="radio"*/}
                    {/*        name="paymentMethod"*/}
                    {/*        value="flik"*/}
                    {/*        checked={flik}*/}
                    {/*        onChange={() => {}} // todo: add handleToggle for when we implement flik*/}
                    {/*    />*/}
                    {/*    Flik*/}
                    {/*</label>*/}
                    {/*<label>*/}
                    {/*<input*/}
                    {/*    type="radio"*/}
                    {/*    name="paymentMethod"*/}
                    {/*    value="kreditna_kartica"*/}
                    {/*    checked={!flik}*/}
                    {/*    onChange={() => {}} // todo: add handleToggle for when we implement flik*/}
                    {/*/>*/}

                    {/*</label>*/}
                    {((ALLOW_DIFFERENT_BILLING_ADDRESS || store.addressNecessary) && !success) && <h4
                        style={{
                            margin: '0',
                            padding: '0',
                            color: theme.text,
                        }}
                    >Podatki o plačniku</h4>}
                    {!store.addressNecessary && ALLOW_DIFFERENT_BILLING_ADDRESS && <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: '10px',
                    }}>
                        <div style={{width: '50%'}}>
                            <CvvRadio name={'payer1'}
                                      id={'notdifferentBillingInfo'}
                                      checked={!mladiVoznikStore.form.step6?.differentBillingAddress}
                                      onChange={() => store.handlePayer(mladiVoznikStore)}
                                      notPrimaryColor={true}
                                      label={'UDELEŽENEC'}
                                      disabled={success}
                            />
                        </div>
                        <div style={{width: '50%'}}>
                            <CvvRadio name={'payer2'}
                                      id={'differentBillingInfo'}
                                      checked={!!mladiVoznikStore.form.step6?.differentBillingAddress}
                                      onChange={() => store.handlePayer(mladiVoznikStore)}
                                      disabled={success}
                                      notPrimaryColor={true}
                                      label={'DRUGA OSEBA'}/>
                        </div>
                    </div> }
                    <input type="hidden" name="transaction_token" id="transaction_token"/>

                    {!store.flik && !success &&
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            height: '100%',
                            flexGrow: '1',
                            gap: '10px',
                        }}>
                            {differentBillingInfo && <div style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                flexDirection: 'column',
                            }
                            }>
                                <CvvInputField label={'IME'}
                                               error={mladiVoznikStore.validators.step6.billingFirstName()}
                                               input={
                                                   <CvvTextInput
                                                       id={'first_name'}
                                                       onChange={(e) => {
                                                           mladiVoznikStore.form.step6!.billingFirstName = e.target.value;
                                                           if (store.startOfForm) {
                                                               store.startOfForm = false;
                                                           }
                                                           store.formDataFilled(mladiVoznikStore);
                                                       }}
                                                       value={mladiVoznikStore.form.step6?.billingFirstName ?? ''}
                                                       type={'text'}
                                                       maxLength={256}
                                                       name={'first_name'}
                                                       onKeyDown={(e) =>
                                                           handleKeyDown(e, 'last_name', 'undefined')}
                                                       disabled={success}
                                                   />
                                               }/>
                                <CvvInputField label={'PRIIMEK'}
                                               error={mladiVoznikStore.validators.step6.billingLastName()}
                                               input={
                                                   <CvvTextInput
                                                       id={'last_name'}
                                                       onChange={(e) => {
                                                           mladiVoznikStore.form.step6!.billingLastName = e.target.value;
                                                           if (store.startOfForm) {
                                                               store.startOfForm = false;
                                                           }
                                                           store.formDataFilled(mladiVoznikStore);
                                                       }}
                                                       value={mladiVoznikStore.form.step6?.billingLastName ?? ''}
                                                       type={'text'}
                                                       maxLength={256}
                                                       name={'last_name'}
                                                       onKeyDown={(e) => handleKeyDown(e, 'first_name', 'undefined')}
                                                       disabled={success}
                                                   />
                                               }/>
                                <GmapsAddressPicker
                                    address={mladiVoznikStore.step6.billingAddress!}
                                    onPlaceSelected={(p) => {
                                        mladiVoznikStore.setBillingAddress(p);
                                        if (store.startOfForm) {
                                            store.startOfForm = false;
                                        }
                                        store.formDataFilled(mladiVoznikStore);
                                    }}
                                    error={mladiVoznikStore.validators.step6.billingAddress()}
                                    noMap={true}
                                />
                            </div>}
                        </div>}
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: isMobilePaymentLayout ? 'column' : 'row',
                        justifyContent: 'space-between',
                        gap: isMobilePaymentLayout ? '10px' : '0',
                    }}
                >
                    <div style={{
                        position: 'relative',
                        backgroundColor: success ? 'rgba(0, 255, 0, .1)' : (paymentError && store.startOfForm) ? 'rgba(255, 0, 0, .1)' : 'white',
                        boxShadow: '0 0.25em 0.5em rgba(0, 45, 98, .3)',
                        width: '100%',
                        padding: '12px',
                        borderRadius: '5px',
                        marginRight: isMobilePaymentLayout ? '0' : '8px',
                        paddingBottom: (store.error || store.bankartError) ? '36px' : '12px',
                        transition: 'all 300ms',
                        border: store.error || store.bankartError ? 'solid 1px red' : undefined,
                        display: 'flex',
                        flexDirection: 'row',
                        height: '100%',
                        justifyContent: 'space-between',

                    }}
                         id={'bankart_payment'}
                    >
                        {/*{store.flik &&*/}
                        {/*    <div style={{*/}
                        {/*        display: 'flex',*/}
                        {/*        flexDirection: 'row',*/}
                        {/*        justifyContent: 'space-between',*/}
                        {/*        alignItems: 'center',*/}
                        {/*        height: '100%',*/}
                        {/*        flexGrow: '1',*/}
                        {/*    }}>*/}
                        {/*        <input*/}
                        {/*            id={'alias'}*/}
                        {/*            placeholder={'Telefonska številka ali e-pošta'}*/}
                        {/*            onChange={(e) => {*/}
                        {/*                handleChange(e)*/}
                        {/*            }}*/}
                        {/*            value={store.alias}*/}
                        {/*            type={'text'}*/}
                        {/*            maxLength={256}*/}
                        {/*            name={'alias'}*/}
                        {/*        />*/}
                        {/*    </div>}*/}


                        {!success && <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            justifyContent: 'space-between',
                            margin: '0',
                            padding: '0',
                        }
                        }>
                            <div id={'card_number'} style={{
                                height: '17px',
                                width: '90%',
                                marginTop: '0.5px'
                            }}></div>
                            <div style={{
                                display: 'flex',
                                gap: '7px',
                                flexDirection: 'row',
                            }}>
                                <input
                                    id={'card_month'}
                                    style={{
                                        ...style_smallcard2,
                                        textAlign: 'right',
                                        width: '25px',
                                        backgroundColor: success ? 'rgba(0, 255, 0, .01)' : (paymentError && store.startOfForm) ? 'rgba(255, 0, 0, .01)' : 'white',
                                    }}
                                    placeholder={'MM'}
                                    onChange={(e) => {
                                        store.changeMonth(e.target.value);
                                    }}
                                    value={store.month}
                                    type={'text'}
                                    inputMode={'numeric'}
                                    maxLength={2}
                                    max={12}
                                    min={1}
                                    name={'month'}
                                    onKeyDown={(e) => handleKeyDown(e, 'card_year', undefined)}
                                    disabled={success || !!paymentError}
                                    autoComplete={'off'}
                                />
                                <p style={{color: '#777', margin: '-1px 0', fontSize: '14px'}}>/</p>
                                <input
                                    id={'card_year'}
                                    style={{
                                        ...style_smallcard2,
                                        backgroundColor: success ? 'rgba(0, 255, 0, .01)' : (paymentError && store.startOfForm) ? 'rgba(255, 0, 0, .01)' : 'white',
                                    }}
                                    placeholder={'YYYY'}
                                    onChange={(e) => {
                                        store.changeYear(e.target.value);
                                    }}
                                    value={store.year}
                                    type={'text'}
                                    inputMode={'numeric'}
                                    maxLength={4}
                                    name={'year'}
                                    onKeyDown={(e) => handleKeyDown(e, undefined, 'card_month')}
                                    disabled={success || !!paymentError}
                                    autoComplete={'off'}
                                />
                                <div id={'card_cvc'} style={{
                                    height: '17px',
                                    width: '50px',
                                    marginTop: '0.5px',
                                }}></div>
                            </div>
                        </div>
                        }
                        {success && <p style={{
                            color: 'green',
                            margin: '0px'
                        }}>Plačilo je bilo uspešno.</p>}
                        {!success && <div style={{
                            backgroundColor: 'rgba(255, 0, 0, 0.05)',
                            position: 'absolute',
                            height: store.error || store.bankartError ? '24px' : '0',
                            overflow: 'hidden',
                            bottom: '0',
                            left: '0',
                            right: '0',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            transition: 'all 300ms',
                        }}>
                            <theme.textTheme.error.span>
                                {store.error && store.bankartError ? store.error + ', ' + store.bankartError : store.error ? store.error : store.bankartError}
                            </theme.textTheme.error.span>
                        </div>}
                    </div>
                    <button
                        // type="submit"
                        disabled={!!btnDisabled}
                        ref={buttonRef}
                        style={{
                            backgroundColor: success ? 'green' : (paymentError && store.startOfForm) ? 'red' : theme.content,
                            outline: 'none',
                            border: 'none',
                            borderRadius: '5px',
                            overflow: 'hidden',
                            boxShadow: '0 0.25em 0.5em rgba(0, 45, 98, .3)',
                            width: isMobilePaymentLayout ? '100%' : (spinning || success ? '50px' : '100px'),
                            cursor: btnDisabled ? 'auto' : 'pointer',
                            opacity: btnDisabled ? '0.7' : '1',
                            transition: 'all 300ms'
                        }}>
                        <theme.textTheme.button.span style={{

                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            color: 'white',
                        }}>
                            {!success && !paymentError && btnDisabled && progress && <TailSpin
                                color={theme.primary}
                                height={'25px'}
                                width={'25px'}/>}
                            {!progress && !success && 'PLAČAJ'}
                            {success && <MdCheck style={{fontSize: '20px'}}/>}
                        </theme.textTheme.button.span>
                    </button>
                </div>
                <CreditCardLogos />
            </div>
        </Form>
    </div>
});
